export const coreAdd = "0xbdD8f09AFc6205BB4b74b4EdC5cF1EeaaAaF15D2";
export const corePair = "0x66c31f72B7F2D557eCf56585c78AD07094449c80";
export const coreVault = "0xeE2505551C94A97df3a4638F6Cb6EccD3B1CEA99";
export const workingNetwork = "0x2a";
